/**
 * A special list item constant used in dropdown type step fields. If this option is selected, then that field will
 * be included in the queries _clear variables. This is helpful for providing a 'None' list option that resets
 * a value by clearing it.
 */
export const NONE_LIST_OPTION = { id: 'NONE_OPTION', name: 'none' } as const;
